import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import FileOpen from "@mui/icons-material/FileOpen";
import CloseIcon from '@mui/icons-material/Close';
import SearchForm from "../../component/searchPage/SearchForm";
import { getImpersonatedActionsLogSearchCriteria, getSearchResults } from "../../service/impersonatedActionsLog";
import SearchInput from "../../component/searchPage/SearchInput";
import SearchDropdown from "../../component/searchPage/SearchDropdown";
import SearchDateInput from "../../component/searchPage/SearchDateInput";
import SearchSapUserDropdown from "../../component/searchPage/SearchSapUserDropdown";

function renderMetadata(params) {
    const { value } = params
    const { t } = useTranslation();
    const [detailsOpen, setDetailsOpen] = useState(false)

    const handleOpenDetails = () => setDetailsOpen(true)
    const handleCloseDetails = () => setDetailsOpen(false)

    return (
        <>
            <button className='btn btn-primary' onClick={handleOpenDetails}>
                <div className='btn-icon'>
                    <FileOpen />
                    {t("View Details")}
                </div>
            </button>
            <Modal open={detailsOpen} onClose={handleCloseDetails}>
                <div className="modal-container">
                    <Box className="modal-box">
                        <IconButton className="close-icon" onClick={handleCloseDetails}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" component="h2" gutterBottom>
                            {t("Changes")}
                        </Typography>
                        <pre>{JSON.stringify(value, null, 3)}</pre>
                    </Box>
                </div>
            </Modal>
        </>
    )
}

const columns = (t) => [
    { field: "impersonator_id", headerName: t("Impersonator ID"), minWidth: 150 },
    { field: "impersonator_email", headerName: t("Impersonator Email"), width: 180, flex: 1 },
    { field: "soldto_account", headerName: t("Sold To Account"), width: 130 },
    { field: "user", headerName: t("SAP Contact"), width: 130 },
    { field: "action", headerName: t("Action"), width: 200 },
    { field: "metadata", headerName: t("Changes Done"), width: 150, renderCell: renderMetadata },
    { field: "activity_date", headerName: t("Date & Time"), width: 150, sort: "desc", flex: 1 }
];

function SearchImpersonatedActionsLog() {
    const { t } = useTranslation();

    return (
        <SearchForm title={t('Impersonated Actions Log')}
            columns={columns(t)}
            criteriaFn={getImpersonatedActionsLogSearchCriteria}
            searchFn={getSearchResults}>
            <div className="search__body--column">
                <SearchInput label={t('Impersonator ID')} dataLabel='impersonatorId' />
                <SearchInput label={t('Impersonator Email')} dataLabel='impersonatorEmail' />
                <SearchDropdown label={t('Action')} dataLabel='actionTypes' />
            </div>
            <div className="search__body--column">
                <SearchDropdown label={t('Sold To Account')} dataLabel='soldToAccountNumber' />
                <SearchSapUserDropdown label={t('SAP Contact')} dataLabel='sapContactId' soldToDataLabel="soldToAccountNumber" />
                <SearchDateInput label={t('Date of Activity')} dataLabel='activityDate' />
            </div>
        </SearchForm>
    )
}

export default SearchImpersonatedActionsLog;